export const getRelative = (url) => {
  const { origin } = window.location
  if (url.indexOf(origin) === 0) return url.slice(origin.length, url.length)
  return url
}
export const isExternalUrl = (url) => /^(.*):\/\//.test(url)
export const isSpecialUrl = (url) =>
  /^(tel|mailto):/.test(url) || url.startsWith('#')
